import { ImageQueryResponse } from "@jmc/core/src/types/ImageQueryReponse";
import { ImagePosition } from "@jmc/solid-design-system/src/components/molecules/Card/Card";

import { CMSButtonProps } from "./CMSButtonProps";
import { CMSCustomFilterOptionProps } from "./CMSCustomFilterOptionProps";
import { CMSSpecialtyProps } from "./CMSSpecialtyProps";

export const CMS_CARD_VARIANT_STACKED = "Image stacked";
export const CMS_CARD_VARIANT_BACKGROUND = "Image as background";

export interface CMSCardProps {
    id: string;
    internal: { type: string };
    display_title: string;
    specialty?: [CMSSpecialtyProps];
    card_image: ImageQueryResponse;
    card_body: string;
    publish_details: {
        locale: string;
        time: string;
    };
    custom_filter_option: [CMSCustomFilterOptionProps];
    display_options: {
        background_color: string;
        title_color: string;
        text_color: string;
        sub_title_reference_and_link_color?: string;
        variant_type: string;
        horizontal_alignment: string;
        image_placement: string;
        padding: string;
        hasoverlay: boolean;
        drop_shadow: boolean;
        image_focus: ImagePosition;
    };
    call_to_action: [{ button: CMSButtonProps }];
}
